import {
  ADD_CART_ITEM,
  UPDATE_CART_ITEMS,
  UPDATE_CART_LOADER,
  UPDATE_VIEW_CART_DATA,
  UPDATE_ACI_MODAL,
  UPDATE_EDIT_DATA,
  UPDATE_SELECTED_ITEM,
} from "../actionTypes/cartTypes";

const initalState = {
  // viewCartData: {},
  //viewCartData: JSON.parse(localStorage.getItem('viewCartData')) || {},
  viewCartData: JSON.parse(sessionStorage.getItem('viewCartData')) || {},
  cartItems: [],
  isCartItemUpdated: {},
  cartLoader: false,
  aciModal: false,
  editData: {},
  selectedItem: {},
};

export function cartReducer(state = initalState, action) {
  switch (action.type) {
    case ADD_CART_ITEM: {
      return {
        ...state,
        isCartItemUpdated: {},
        cartItems: [...state.cartItems, action.payload],
      };
    }
    case UPDATE_CART_ITEMS: {
      return {
        ...state,
        cartItems: action.payload,
      };
    }
    case UPDATE_CART_LOADER: {
      return {
        ...state,
        cartLoader: action.payload,
      };
    }
    case UPDATE_VIEW_CART_DATA: {
      // localStorage.setItem('viewCartData', JSON.stringify(action.payload));
      sessionStorage.setItem('viewCartData', JSON.stringify(action.payload));
      return {
        ...state,
        viewCartData: action.payload,
      };
    }
    case UPDATE_ACI_MODAL: {
      return {
        ...state,
        aciModal: action.payload,
      };
    }
    case UPDATE_EDIT_DATA: {
      return {
        ...state,
        editData: action.payload,
      };
    }
    case UPDATE_SELECTED_ITEM: {
      return {
        ...state,
        selectedItem: action.payload,
      };
    }
    default:
      return state;
  }
}
